

function Footer(props) {
  return (
    <div className="Footer">
         <p style={props.stylesContentGerman}>&#169; Juliette Salevsky</p>
         <p style={props.stylesContentEnglish}>&#169; Juliette Salevsky</p>
    </div>
  );
}

export default Footer;